import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const AlignHorizontalDistributeEnd: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '4', y: '5', width: '6', height: '14', rx: '2' }],
    ['rect', { x: '14', y: '7', width: '6', height: '10', rx: '2' }],
    ['path', { d: 'M10 2v20' }],
    ['path', { d: 'M20 2v20' }],
  ],
];

export default AlignHorizontalDistributeEnd;
